import { getPosterImage } from "../utils/posterImageFunction";

export const usePosterImage = async (link, defaultImage) => {
    const fetchedPosterImage = await getPosterImage(link, defaultImage);

    return fetchedPosterImage;
};
